<template>
	<div v-if="enableAuditLog" class="user-panel">
		<table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr height="56px">
                <td colspan="10">
                    <div class="panel-command-box">
                        <div style="padding-top:8px;padding-bottom:8px">
                            <el-date-picker v-model="datePickerValue" type="datetimerange" range-separator="To" start-placeholder="Start date" end-placeholder="End date" @change="getAuditLogList()"></el-date-picker>
                            <el-select v-model="selectedFunctionName" style="width:300px;padding-left:15px;padding-right:15px" @change="getAuditLogList()">
                                <div v-for="auditFunction in auditFunctionListForSelection">
                                    <el-option style="font-size:12px" :label="auditFunction.displayName" :value="auditFunction.name"></el-option>
                                </div>
                            </el-select>
                        </div>
                    </div>
                </td>
            </tr>
            <tr height="36px" class="itemheader">
                <td width="15%" valign="top" class="information-header" v-t="'message.item_exec_datetime'"></td>
                <td width="15%" valign="top" class="information-header" v-t="'message.item_ip_address'"></td>
                <td width="15%" valign="top" class="information-header" v-t="'message.item_function_name'"></td>
                <td width="10%" valign="top" class="information-header" v-t="'message.item_userId'"></td>
                <td width="70%" valign="top" class="information-header">
                    <div class="information-header-left" v-t="'message.item_data'"></div>
                    <div class="information-header-right">
                        <button class="transparent-button" type="button" v-on:click="exportToCsv()">
                            <img style="height:18px" src="../assets/icon_download.svg"/><span class="normal-command-text" v-t="'message.action_auditLog_export'"></span>
                        </button>
                        <button class="transparent-button" type="button" v-on:click="getAuditLogList()">
                            <img style="height:18px" src="../assets/icon_load.svg"/><span class="normal-command-text" v-t="'message.action_talk_refresh'"></span>
                        </button>
                    </div>
                </td>
            </tr>
            <tr class="itemheader">
                <td valign="top" colspan="10">
                    <div class="inner-panel">
                        <table width=100% cellpadding=0 cellspacing=0>
                            <tr class="partner-record" v-for="auditLog in auditLogList">
                                <td width="15%" class="audit-log">{{ auditLog.execDatetime.toLocaleString() }}</td>
                                <td width="15%" class="audit-log">{{ auditLog.ip }}</td>
                                <td width="15%" class="audit-log">{{ auditLog.functionName }}</td>
                                <td width="10%" class="audit-log">{{ auditLog.userName }}</td>
                                <td width="70%" class="audit-log" style="padding-right:20px">{{ auditLog.data }}</td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
	</div>
	<div v-else class="user-panel">
        <div style="text-align:center;padding-top:40px">
            {{ messageOptionNotSupported }}
        </div>
	</div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data () {
        return {
            enableAuditLog: false,
            messageOptionNotSupported: null,
            auditFunctionListForSelection: [],
            auditFunctionListAll: [],
            auditLogList: [],
            selectedFunctionName: "ALL",
            datePickerValue: null,
        };
    },
    methods: {
        getAuditLogList() {
            this.auditLogList = [];
            if (this.datePickerValue == null) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"info_need_time_range_of_audit_log"));
                return;
            }
            let parameter = {};
            if (this.selectedFunctionName != "ALL") {
                parameter.functionName = this.selectedFunctionName
            }
            parameter.fromDateTime = this.datePickerValue[0].toISOString();
            parameter.toDateTime = this.datePickerValue[1].toISOString();
            let self = this;
            server.post('/getauditlog', parameter)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            if (res.data.auditLog.length > 0) {
                                for (let auditLog of res.data.auditLog) {
                                    let auditData;
                                    let jsonData;
                                    switch(auditLog.functionName) {
                                        case "Login":
                                        case "Login2ndPhase":
                                        case "BellLogin":
                                            try {
                                                let logData = JSON.parse(auditLog.data)
                                                auditLog.userName = logData.userName;
                                                auditData = self.getActionDataOfLogin(logData);
                                            } catch(e) {
                                                // old audit log is not json format.
                                                if (auditLog.data.indexOf("SUCCESS") > 0) {
                                                    auditData = commonUtil.getMessageText(self.$i18n,"item_succeeded");
                                                } else {
                                                    auditData = commonUtil.getMessageText(self.$i18n,"item_failed");
                                                }
                                            }
                                            break;
                                        case "PurchaseLicense":
                                            jsonData = JSON.parse(auditLog.data);
                                            auditData = self.getActionDataOfPurchaseLicense(jsonData.orderInfo, jsonData.number, jsonData.recurring, jsonData.charge );
                                            break;
                                        case "OnlinePurchaseCompensate":
                                            auditData = self.getOnlinePurchaseCompensate(JSON.parse(auditLog.data));
                                            break;
                                        case "ModifyContractStatus":
                                            auditData = self.getActionDataOfModifyContractStatus(JSON.parse(auditLog.data));
                                            break;
                                        case "GetURL":
                                            auditData = self.getActionDataOfGroupTalkRecord(JSON.parse(auditLog.data));
                                            break;
                                        case "GetPeerURL":
                                            auditData = self.getActionDataOfPeerTalkRecord(JSON.parse(auditLog.data));
                                            break;
                                        case "GetTalkrecords":
                                            auditData = self.getActionDataOfGroupTalkRecordList(JSON.parse(auditLog.data));
                                            break;
                                        case "GetPeerTalkrecords":
                                            auditData = self.getActionDataOfPeerTalkRecordList(JSON.parse(auditLog.data));
                                            break;
                                        case "CreateDeferredProcessInfo":
                                        case "DeleteDeferredProcessInfo":
                                            auditData = self.getActionDataOfDeferredRequest(auditLog.functionName, JSON.parse(auditLog.data));
                                            break;
                                        case "ModifyPermitIPAddressList":
                                            auditData = self.getActionDataOfModifyPermitIp(JSON.parse(auditLog.data));
                                            break;
                                        case "ModifyConsole2FA":
                                            auditData = self.getActionDataOfTwoPhaseAuthOtherUser(JSON.parse(auditLog.data));
                                            break;
                                        case "ModifyEnableConsole2FA":
                                            auditData = self.getActionDataOfEnableTwoPhaseMethod(JSON.parse(auditLog.data));
                                            break;
                                        case "TwoPhaseMethod":
                                            auditData = self.getTenantOptionONOFF(JSON.parse(auditLog.data));
                                            break;
                                        case "DeviceManagement":
                                            auditData = self.getDeviceManagement(JSON.parse(auditLog.data));
                                            break;
                                        case "ApplicationControl":
                                            auditData = self.getApplicationControl(JSON.parse(auditLog.data));
                                            break;
                                    }
                                    self.auditLogList.push(
                                        {
                                            execDatetime: new Date(auditLog.execDatetime),
                                            ip: auditLog.ip,
                                            functionName: self.getDisplayFunctionName(auditLog.functionName),
                                            userName: auditLog.userName,
                                            data: auditData
                                        });

                                }
                                if (res.data.status ==  constants.STATUS_SUCCESS) {
                                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_audit_log_get_completed").replace("{count}",res.data.auditLog.length));
                                } else {
                                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_audit_log_exceeded").replace("{maxCount}",self.auditLogList.length));
                                }
                            } else {
                                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_audit_log"));
                            }
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_access_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getAuditLogList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getAuditLogList", error);
                });
        },
        exportToCsv() {
            const universalBOM = "\uFEFF";
            let csvData = commonUtil.getMessageText(this.$i18n,"title_csv_audit_log");
            for (let auditLog of this.auditLogList) {
                csvData += commonUtil.getFormattedLocalDatetime(auditLog.execDatetime) + ",";
                csvData += auditLog.ip + ",";
                csvData += auditLog.functionName + ",";
                csvData += auditLog.userName + ",";
                csvData += auditLog.data;
                csvData += "\n";
            }
            const blob = new Blob([universalBOM + csvData], { type: 'application/csv;charset=UTF-8' });
            const downloadFileName = "auditLog.csv";
            commonUtil.downloadFile(blob, downloadFileName)
        },
        getDisplayDateTime(datetime) {
            return new Date(datetime).toLocaleString();
        },
        getDisplayFunctionName(functionName) {
            let auditFunction = this.auditFunctionListAll.filter(function(item, index){
                if ((item.name).indexOf(functionName) >= 0) return true;
            });
            if (auditFunction.length > 0) {
                return auditFunction[0].displayName;
            } else {
                return functionName
            }
        },
        getActionDataOfDeferredRequest(functionName, jsonData) {
            let operationCode;
            if (functionName == "CreateDeferredProcessInfo") {
                operationCode = jsonData.deferredOperationRequestList[0].operationCode;
            } else {
                operationCode = jsonData.operationCode;
            }
            switch(operationCode) {
                case constants.DEFERRED_MONTH_TO_YEAR:
                    return commonUtil.getMessageText(this.$i18n,"action_change_contract").replace("{contract}",commonUtil.getPurchasePeriodTypeName(this.$i18n, constants.PURCHASE_PERIOD_YEARLY));
                case constants.DEFERRED_YEAR_TO_MONTH:
                    return commonUtil.getMessageText(this.$i18n,"action_change_contract").replace("{contract}",commonUtil.getPurchasePeriodTypeName(this.$i18n, constants.PURCHASE_PERIOD_MONTHLY));
                case constants.DEFERRED_DOWNGRADE_TE_TO_TL:
                case constants.DEFERRED_DOWNGRADE_LL_TO_TL:
                case constants.DEFERRED_DOWNGRADE_LE_TO_TL:
                    return commonUtil.getMessageText(this.$i18n,"action_change_contract").replace("{contract}",commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_LITE));
                case constants.DEFERRED_DOWNGRADE_TE_TO_LL:
                case constants.DEFERRED_DOWNGRADE_LE_TO_LL:
                    return commonUtil.getMessageText(this.$i18n,"action_change_contract").replace("{contract}",commonUtil.getPlanName(constants.LICENSE_PLAN_LIVE_LITE));
                case constants.DEFERRED_DOWNGRADE_LL_TO_TE:
                case constants.DEFERRED_DOWNGRADE_LE_TO_TE:
                    return commonUtil.getMessageText(this.$i18n,"action_change_contract").replace("{contract}",commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_ENT));
                default:
                    return jsonData.operationCode;
            }
        },
        getActionDataOfModifyContractStatus(jsonData) {
            switch(jsonData.newStatus) {
                case constants.CONTRACT_ACTIVE:
                    return commonUtil.getMessageText(this.$i18n,"action_contract_auto_update");
                case constants.CONTRACT_NOUPDATE:
                    return commonUtil.getMessageText(this.$i18n,"action_contract_no_update");
                default:
                    return jsonData.newStatus;
            }
        },
        getActionDataOfGroupTalkRecord(jsonData) {
            let data = commonUtil.getMessageText(this.$i18n,"item_groupDisplayName") + ":"
            data += jsonData[0].talkgroupName + " / ";
            data += commonUtil.getMessageText(this.$i18n,"item_talk_start_datetime") + ":"
            data += this.getDisplayDateTime(jsonData[0].startTime) + " / ";
            data += commonUtil.getMessageText(this.$i18n,"item_talk_talker") + ":"
            data += jsonData[0].userName ;
            if (jsonData[0].type != null) {
                data += " / " + commonUtil.getMessageText(this.$i18n,"item_type") + ":"
                if (jsonData[0].type == constants.TALK_RECORD_VOICE) {
                    data += commonUtil.getMessageText(this.$i18n,"item_type_voice")  ;
                } else {
                    data += commonUtil.getMessageText(this.$i18n,"item_type_video")  ;
                }
            }
            return data;
        },
        getActionDataOfGroupTalkRecordList(jsonData) {
            let data = "";
            switch(jsonData.status) {
                case constants.STATUS_SUCCESS:
                case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    let from = "";
                    let to = "";
                    if (typeof jsonData["fromDate"] === "undefined") {
                        from = jsonData["fromId"];
                        to = jsonData["toId"];
                    } else {
                        from = this.getLocaleDatetimeString(jsonData["fromDate"]);
                        to = this.getLocaleDatetimeString(jsonData["toDate"]);
                    }
                    data = commonUtil.getMessageText(this.$i18n, "info_audit_log_group_talkRecordList_Succeeded")
                        .replace("{groupName}", jsonData["groupName"])
                        .replace("{from}", from)
                        .replace("{to}", to)
                        .replace("{count}", jsonData["recordCount"]);
                    break;
                case constants.STATUS_ERROR_DENIED:
                    data = commonUtil.getMessageText(this.$i18n, "info_audit_log_group_talkRecordList_Failed")
                        .replace("{reason}", commonUtil.getMessageText(this.$i18n, "error_access_denied"))
                        .replace("{groupName}", jsonData["groupName"])
                        .replace("{from}", this.getLocaleDatetimeString(jsonData["fromDate"]))
                        .replace("{to}", this.getLocaleDatetimeString(jsonData["toDate"]));
                    break;
                case constants.STATUS_ERROR_INVALID_PARAMETER:
                    data = commonUtil.getMessageText(this.$i18n, "info_audit_log_talkRecordList_param_error")
                        .replace("{paramData}", jsonData["paramData"])
                    break;
                default:
                    data = jsonData;
            }
            return data;
        },
        getActionDataOfPeerTalkRecord(jsonData) {
            let data = jsonData[0].userName1 + " < - > ";
            data += jsonData[0].userName2 + " / ";
            data += commonUtil.getMessageText(this.$i18n,"item_talk_start_datetime") + ":"
            data += this.getDisplayDateTime(jsonData[0].startTime);
            return data;
        },
        getActionDataOfPeerTalkRecordList(jsonData) {
            let data = "";
            switch(jsonData.status) {
                case constants.STATUS_SUCCESS:
                case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    let from = "";
                    let to = "";
                    if (typeof jsonData["fromDate"] === "undefined") {
                        from = jsonData["fromId"];
                        to = jsonData["toId"];
                    } else {
                        from = this.getLocaleDatetimeString(jsonData["fromDate"]);
                        to = this.getLocaleDatetimeString(jsonData["toDate"]);
                    }
                    data = commonUtil.getMessageText(this.$i18n, "info_audit_log_peer_talkRecordList_Succeeded")
                        .replace("{userName1}", jsonData["userName1"])
                        .replace("{userName2}", jsonData["userName2"])
                        .replace("{from}", from)
                        .replace("{to}", to)
                        .replace("{count}", jsonData["recordCount"]);
                    break;
                case constants.STATUS_ERROR_DENIED:
                    data = commonUtil.getMessageText(this.$i18n, "info_audit_log_peer_talkRecordList_Failed")
                        .replace("{reason}", commonUtil.getMessageText(this.$i18n, "error_access_denied"))
                        .replace("{userName1}", jsonData["userName1"])
                        .replace("{userName2}", jsonData["userName2"])
                        .replace("{from}", this.getLocaleDatetimeString(jsonData["fromDate"]))
                        .replace("{to}", this.getLocaleDatetimeString(jsonData["toDate"]));
                    break;
                case constants.STATUS_ERROR_INVALID_PARAMETER:
                    data = commonUtil.getMessageText(this.$i18n, "info_audit_log_talkRecordList_param_error")
                        .replace("{paramData}", jsonData["paramData"])
                    break;
                default:
                    data = jsonData;
            }
            return data;
        },
        getActionDataOfLogin(jsonData) {
            switch(jsonData.errorCode) {
                case constants.STATUS_SUCCESS:
                    return commonUtil.getMessageText(this.$i18n,"item_succeeded");
                case constants.STATUS_ERROR_INVALID_PARAMETER:
                    return commonUtil.getMessageText(this.$i18n,"item_login_fail_invalid");
                case constants.STATUS_ERROR_INVALID_TWO_PHASE_METHOD:
                    return commonUtil.getMessageText(this.$i18n,"item_login_fail_invalid_two_phase_auth");
                case constants.STATUS_ERROR_DENIED:
                    return commonUtil.getMessageText(this.$i18n,"item_login_fail_not_permitted");
                default:
                    return commonUtil.getMessageText(this.$i18n,"item_failed");
            }
        },
        getActionDataOfModifyPermitIp(jsonData) {
            let data = "";
            if (jsonData.requestType == 0) {
                data += commonUtil.getMessageText(this.$i18n,"item_change_permit_range") + "：";
                if (jsonData.permitType == 0) {
                    data += commonUtil.getMessageText(this.$i18n,"item_partial_ip_permitted") + " -> " + commonUtil.getMessageText(this.$i18n,"item_all_ip_permitted");
                } else {
                    data += commonUtil.getMessageText(this.$i18n,"item_all_ip_permitted") + " -> " + commonUtil.getMessageText(this.$i18n,"item_partial_ip_permitted");
                }
            }
            if (!(typeof jsonData.addIpAddressList === "undefined")) {
                if (data.length > 0) {
                    data += " / ";
                }
                data += commonUtil.getMessageText(this.$i18n,"common_action_add") + "：";
                for (let index = 0 ; index < jsonData.addIpAddressList.length; index ++) {
                    if (index > 0) {
                        data += " ";
                    }
                    data += jsonData.addIpAddressList[index].definedIp;
                    if (!(typeof jsonData.addIpAddressList[index].description === "undefined")) {
                        if (jsonData.addIpAddressList[index].description != "") {
                            data += "(" + jsonData.addIpAddressList[index].description + ")"
                        }
                    }
                }
            }
            if (!(typeof jsonData.modifyIpAddressList === "undefined")) {
                if (data.length > 0) {
                    data += " / ";
                }
                data += commonUtil.getMessageText(this.$i18n,"item_change") + "：";
                for (let index = 0; index < jsonData.modifyIpAddressList.length; index ++) {
                    if (index > 0) {
                        data += " ";
                    }
                    data += jsonData.modifyIpAddressList[index].definedIp;
                    if (!(typeof jsonData.modifyIpAddressList[index].newDefinedIp === "undefined")) {
                        data += " -> " + jsonData.modifyIpAddressList[index].newDefinedIp;
                    }
                    if (!(typeof jsonData.modifyIpAddressList[index].newDescription === "undefined")) {
                        if (jsonData.modifyIpAddressList[index].newDescription == "") {
                            data += "( - )";
                        } else {
                            data += "(" + jsonData.modifyIpAddressList[index].newDescription + ")";
                        }
                    }
                }
            }
            if (!(typeof jsonData.removeIpAddressList === "undefined")) {
                if (data.length > 0) {
                    data += " / ";
                }
                data += commonUtil.getMessageText(this.$i18n,"common_action_delete") + "：";
                for (let index = 0; index < jsonData.removeIpAddressList.length; index ++) {
                    if (index > 0) {
                        data += " ";
                    }
                    data += jsonData.removeIpAddressList[index].definedIp;
                }
            }
            return data;
        },
        getTenantOptionONOFF(jsonData) {
            const { request } = jsonData;
            if (request) {
                return commonUtil.getMessageText(this.$i18n, "value_on");
            } else {
                return commonUtil.getMessageText(this.$i18n, "value_off");
            }
        },
        getDeviceManagement(jsonData){
            const { operation, requestData: requestJson } = jsonData;
            const requestData = JSON.parse(requestJson);
            switch (operation) {
                case "OnOff":
                    return `${commonUtil.getMessageText(this.$i18n, "item_device_management_setting_label")}: ${this.getTenantOptionONOFF(requestData)}`;
                case "updateApprovalStatus":
                    const { deviceId: approvalDeviceId, approvalStatus } = requestData;
                    return `${commonUtil.getMessageText(this.$i18n, "dialog_device_management_update")}: ${approvalDeviceId} / ${commonUtil.getDeviceManagementApprovalStatusName(this.$i18n, approvalStatus)}`;
                case "delete":
                    const { deviceId: deleteDeviceId } = requestData;
                    return `${commonUtil.getMessageText(this.$i18n, "dialog_device_management_delete")}: ${deleteDeviceId}`;
                default:
                    break;
            }
        },
        getApplicationControl(jsonData) {
            const { requestType } = jsonData;
            switch (requestType) {
                case 1:
                    return commonUtil.getMessageText(this.$i18n, "button_app_control_termination");
                case 2:
                    return commonUtil.getMessageText(this.$i18n, "button_app_control_launch");
                default:
                    return `Editing omission, requestType = ${requestType}.`;
            }
        },
        getActionDataOfPurchaseLicense(orderInfo, numberLicense, recurringLicense, chargeLicense) {
            let purchaseData;
            if ((typeof orderInfo.purchasePlanType === "undefined") || (orderInfo.purchasePlanType == constants.LICENSE_PLAN_SEPARATE)) {
                if (jsonData.orderInfo.requestType == constants.PURCHASE_REQUEST_NEW) {
                    purchaseData = commonUtil.getMessageText(this.$i18n,"item_new_purchase") + ":";
                } else {
                    purchaseData = commonUtil.getMessageText(this.$i18n,"item_change") + ":";
                }
                if (numberLicense.length > 0) {
                    purchaseData += commonUtil.getMessageText(this.$i18n,"item_license_basic") + "[";
                    for (let index = 0 ; index < numberLicense.length ; index++) {
                        purchaseData += commonUtil.getLicenseName(this.$i18n, numberLicense[index].type)
                        if (orderInfo.requestType == constants.PURCHASE_REQUEST_MODIFY) {
                            purchaseData += ":" + numberLicense[index].originalQuantity + "->"+ numberLicense[index].totalQuantity;
                        } else {
                            purchaseData += ":" + numberLicense[index].totalQuantity;
                        }
                        if ((index + 1) < numberLicense.length) {
                            purchaseData += " / ";
                        }
                    }
                    purchaseData += "]";
                }
                if (recurringLicense.length > 0) {
                    purchaseData += " | " + commonUtil.getMessageText(this.$i18n,"item_license_recurring") + " [";
                    for (let index = 0 ; index < recurringLicense.length ; index++) {
                        purchaseData += commonUtil.getLicenseName(this.$i18n, recurringLicense[index].type)
                        let unitName = commonUtil.getUnitName(this.$i18n, recurringLicense[index].type);
                        if (orderInfo.requestType == constants.PURCHASE_REQUEST_MODIFY) {
                            purchaseData += ":" + recurringLicense[index].originalQuantity + unitName + "->"+ recurringLicense[index].totalQuantity + unitName;
                        } else {
                            purchaseData += ":" + recurringLicense[index].totalQuantity + unitName;
                        }
                        if ((index + 1) < jsonData.recurringLicense.length) {
                            purchaseData += " / ";
                        }
                    }
                    purchaseData += "]";
                }
                if (chargeLicense.length > 0) {
                    purchaseData += " | " + commonUtil.getMessageText(this.$i18n,"item_license_charge") + " [";
                    for (let index = 0 ; index < chargeLicense.length ; index++) {
                        purchaseData += commonUtil.getLicenseName(this.$i18n, chargeLicense[index].type)
                        purchaseData += ":" + chargeLicense[index].totalQuantity + commonUtil.getUnitName(this.$i18n, chargeLicense[index].type);
                        if ((index + 1) < chargeLicense.length) {
                            purchaseData += " / ";
                        }
                    }
                    purchaseData += "]";
                }
            } else {
                switch(orderInfo.requestType) {
                    case constants.PURCHASE_REQUEST_NEW_PLAN:
                        purchaseData = commonUtil.getMessageText(this.$i18n,"item_new_purchase") + ":";
                        purchaseData += commonUtil.getPlanName(orderInfo.purchasePlanType)
                        purchaseData += ":" + numberLicense[0].totalQuantity;
                        break;
                    case constants.PURCHASE_REQUEST_MODIFY_PLAN:
                        purchaseData = commonUtil.getMessageText(this.$i18n,"action_change_license") +":";
                        purchaseData += commonUtil.getPlanName(orderInfo.purchasePlanType)
                        purchaseData += ":[" + numberLicense[0].originalQuantity + "->"+ numberLicense[0].totalQuantity;
                        purchaseData += "]";
                        break;
                    case constants.PURCHASE_REQUEST_CHANGE_PLAN:
                        purchaseData = commonUtil.getMessageText(this.$i18n,"action_change_plan") +":";
                        switch(orderInfo.purchasePlanType) {
                            case constants.PLAN_UPGRADE_TL_TE:
                                purchaseData += commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_LITE) + "->" + commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_ENT);
                                break;
                            case constants.PLAN_UPGRADE_TL_LL:
                                purchaseData += commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_LITE) + "->" + commonUtil.getPlanName(constants.LICENSE_PLAN_LIVE_LITE);
                                break;
                            case constants.PLAN_UPGRADE_TL_LE:
                                purchaseData += commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_LITE) + "->" + commonUtil.getPlanName(constants.LICENSE_PLAN_LIVE_ENT);
                                break;
                            case constants.PLAN_UPGRADE_TE_LE:
                                purchaseData += commonUtil.getPlanName(constants.LICENSE_PLAN_TALK_ENT) + "->" + commonUtil.getPlanName(constants.LICENSE_PLAN_LIVE_ENT);
                                break;
                            case constants.PLAN_UPGRADE_LL_LE:
                                purchaseData += commonUtil.getPlanName(constants.LICENSE_PLAN_LIVE_LITE) + "->" + commonUtil.getPlanName(constants.LICENSE_PLAN_LIVE_ENT);
                                break;
                        }
                        break;
                }
            }
            return purchaseData;
        },
        getLocaleDatetimeString(convertDatetime) {
            let dateObj = new Date(convertDatetime);
            return new Date(Date.UTC(
                dateObj.getUTCFullYear(),
                dateObj.getUTCMonth(),
                dateObj.getUTCDate(),
                dateObj.getUTCHours(),
                dateObj.getUTCMinutes(),
                dateObj.getUTCSeconds()
            )).toLocaleString();
        },
        getOnlinePurchaseCompensate(auditData) {
            let jsonData = JSON.parse(auditData.jsonData);
            let licenseList = commonUtil.getLicenseList(this.$i18n);
            let numberLicense = [];
            let recurringLicense = [];
            let chargeLicense = [];
            for (let license of licenseList) {
                let licenseInfo = jsonData.numberContractUpdateParamMap[license.value];
                if (license.value < constants.RECURRING_SPEECH_TEXT) {
                    if (typeof licenseInfo != "undefined") {
                        numberLicense.push({type: license.value, totalQuantity:licenseInfo.newNumber, originalQuantity:licenseInfo.originalNumber});
                    }
                } else if ((license.value >= constants.RECURRING_SPEECH_TEXT) && (license.value < constants.CHARGE_SPEECH_TEXT)) {
                    if (typeof licenseInfo != "undefined") {
                        recurringLicense.push({type: license.value, totalQuantity:licenseInfo.newNumber, originalQuantity:licenseInfo.originalNumber});
                    }
                } else {
                    if (typeof licenseInfo != "undefined") {
                        chargeLicense.push({type: license.value, totalQuantity:licenseInfo.newNumber, originalQuantity:licenseInfo.originalNumber});
                    }
                }
            }
            return this.getActionDataOfPurchaseLicense(auditData, numberLicense, recurringLicense, chargeLicense);
        },
        getActionDataOfTwoPhaseAuthOtherUser(jsonData) {
            let data = "";
            switch(jsonData.errorCode) {
                case constants.STATUS_SUCCESS:
                    data += commonUtil.getMessageText(this.$i18n,"item_succeeded");
                    break;
                default:
                    data += commonUtil.getMessageText(this.$i18n,"item_failed");
                    break;
            }
            data += " : "
            data += "targetUserName : "
            data += jsonData.targetUserName
            return data;
        },
        getActionDataOfEnableTwoPhaseMethod(jsonData) {
            let data = "";
            switch(jsonData.errorCode) {
                case constants.STATUS_SUCCESS:
                    data += commonUtil.getMessageText(this.$i18n,"item_succeeded");
                    break;
                default:
                    data += commonUtil.getMessageText(this.$i18n,"item_failed");
                    break;
            }
            data += " : "
            data += jsonData.enable ? "ON" : "OFF";
            return data;
        },
        setOptionNotSupportedMessage() {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                this.messageOptionNotSupported = commonUtil.getMessageText(this.$i18n,"error_need_audit_log_option");
            } else {
                this.messageOptionNotSupported = commonUtil.getMessageText(this.$i18n,"error_not_support_option_by_this_plan");
            }
        }
    },
    created: function() {
        if (this.appData.loaded) {
            if (commonUtil.isEnableOption(this.appData, constants.LICENSE_ACCESS_LOG)) {
                this.enableAuditLog = true;
                this.getAuditLogList();
            } else {
                this.setOptionNotSupportedMessage();
            }
        }
        this.auditFunctionListForSelection = commonUtil.getAuditFunctionCategoryListForTenant(this.$i18n, this.appData.onlinePurchase);
        this.auditFunctionListAll = commonUtil.getAuditFunctionListForTenant(this.$i18n, true);
        let currentDate = new Date()
        this.datePickerValue = [ new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate()) , new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate() + 1) ];
    },
    watch: {
        'appData.onlinePurchase'(newVal) {
            if (this.appData.onlinePurchase) {
                this.auditFunctionListForSelection = commonUtil.getAuditFunctionListForTenant(this.$i18n, true);
            }
        },
        '$i18n.locale'(newVal) {
            this.auditFunctionListForSelection = commonUtil.getAuditFunctionListForTenant(this.$i18n, this.appData.onlinePurchase);
            this.auditFunctionListAll = commonUtil.getAuditFunctionListForTenant(this.$i18n, true);
        },
        'appData.loaded' (newVal) {
            if (this.appData.loaded) {
                if (commonUtil.isEnableOption(this.appData, constants.LICENSE_ACCESS_LOG)) {
                    this.enableAuditLog = true;
                    this.getAuditLogList();
                } else {
                    this.setOptionNotSupportedMessage()
                }
            }
        },
    },
    components: {
    },
    props: ['appData']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>

<style scoped>
.el-switch__label.log-switch {
    color: #848991;
}
.el-switch__label.log-switch.is-active {
    color: #5171cb;
}
.inner-panel {
	position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
	background-color: #ffffff;
}

.information-header {
    padding: 10px 0 10px 20px;
    color: #848991;
    background-color:#f6f6f6;
    font-size: 12px;
}

.information-header-left {
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
  float: left;
}

.information-header-right {
  padding-right: 10px;
  position: relative;
  text-align : right;
  vertical-align: middle;
  font-size: 12px;
}

.partner-record-title {
  width: 100%;
  background-color: #f6f6f6;
}

.partner-record {
    border-bottom:1px #eee solid;
}

.partner-item-title {
    width: 40%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
}

.audit-log {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    color: #848991;
}
</style>
